export default __webpack_public_path__ + "static/media/CodaCaption-ExtraBold.1d82a669.ttf";